// Mengdekalkulator: areal (m²) × tykkelse (cm) × tetthet (t/m³) gir tonn.
// Tetthetene er veiledende standardverdier som ikke er bekreftet ennå. Bestiller kan overstyre dem.

export const DEFAULT_DENSITY = { soil: 1.6, gravel: 1.8, crushed_stone: 1.7, sand: 1.6, other: 1.6 };

export const densityFor = massType => DEFAULT_DENSITY[massType] ?? 1.6;

const num = v => Number(String(v ?? '').replace(',', '.'));

// Tonn avrundet til én desimal, eller null ved ugyldig input eller under 0,1 tonn.
export function calcTons({ areaM2, thicknessCm, density }) {
  const area = num(areaM2), thickness = num(thicknessCm), d = num(density);
  if ([areaM2, thicknessCm, density].some(v => String(v ?? '').trim() === '')) return null;
  if (![area, thickness, d].every(n => Number.isFinite(n) && n > 0)) return null;
  const tons = Math.round(((area * thickness) / 100) * d * 10) / 10;
  return tons >= 0.1 ? tons : null;
}
